export const environment = {
    siteId: 1,
    name: 'catering vejer',
    apiBaseUrl: 'https://cateringvejer-api-staging.clicktotravel.es/api',
    baseUrl: 'https://cateringvejer-api-staging.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: '96YMNQJyBx-V32qr',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: true,
    booking_engine_extern: true,
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
};
